"use client";

import { useEffect } from "react";

/**
 * Tiny client-only effect: on mount, POSTs to /api/last-login to
 * record this visitor's "login time". The server-side handler
 * stores the max of the candidate and what's already on disk, so
 * the "Last login:" line on the homepage reflects the most recent
 * visitor (across all sessions/users), not just the current one.
 *
 * No UI is rendered.
 */
export function RecordLastLogin() {
  useEffect(() => {
    // Fire and forget. We don't await — a slow/failing network
    // call shouldn't affect the page, and the user doesn't need
    // to see anything.
    void fetch("/api/last-login", { method: "POST" }).catch(() => {
      // Swallow network errors. The server will still show its
      // own clock time on the next request via /api/last-login GET.
    });
  }, []);
  return null;
}
